/**
 * NPC Cleric AI — Types & Interfaces
 *
 * Decision types for autonomous NPC healer.
 * Agent hook allows paid-tier upgrade from heuristic to LLM.
 */
// ---------------------------------------------------------------------------
// Personality barks
// ---------------------------------------------------------------------------
export const CLERIC_BARKS = {
    heal: [
        'Hold still.',
        'This would not be necessary if you used cover.',
        'Again?',
    ],
    damage: [
        'Ubtao sees you.',
        'Return to the earth.',
    ],
    buff: [
        'Stand firm.',
        'The jungle watches over us.',
    ],
    revive: [
        'Not today.',
        'I did not walk this far to bury you.',
    ],
    idle: [],
};
export function pickBark(category) {
    const barks = CLERIC_BARKS[category];
    if (barks.length === 0)
        return undefined;
    return barks[Math.floor(Math.random() * barks.length)];
}
//# sourceMappingURL=npc-cleric-types.js.map